export enum SocAssessmentSections {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  PATIENT_OVERVIEW = 'patient-overview',
  MEDICAL_BACKGROUND = 'medical-background',
  MEDICATIONS = 'medications',
  SKILLED_NEEDS = 'skilled-needs',
  ADL_NEEDS = 'adl-needs',
  DISCHARGE_PLANNING = 'discharge-planning',
  AUTHORIZATION = 'authorization',
  PLAN_OF_CARE = 'plan-of-care',
  VISIT_SCHEDULING = 'visit-scheduling',
  SUPERVISORY_REVIEW = 'supervisory-review',
  NARRATIVE = 'narrative',
  FINAL_STEPS = 'final-steps'
}

export const SocAssessmentAnchors = [
  {
    key: SocAssessmentSections.ASSESSMENT_OVERVIEW,
    href: '#assessment-overview',
    title: 'Assessment Overview'
  },
  {
    key: SocAssessmentSections.PATIENT_OVERVIEW,
    href: '#patient-overview',
    title: 'Patient Overview'
  },
  {
    key: SocAssessmentSections.MEDICAL_BACKGROUND,
    href: '#medical-background',
    title: 'Medical Background'
  },
  {
    key: SocAssessmentSections.MEDICATIONS,
    href: '#medications',
    title: 'Medications'
  },
  {
    key: SocAssessmentSections.SKILLED_NEEDS,
    href: '#skilled-needs',
    title: 'Skilled Needs'
  },
  {
    key: SocAssessmentSections.ADL_NEEDS,
    href: '#adl-needs',
    title: 'ADL Needs'
  },
  {
    key: SocAssessmentSections.DISCHARGE_PLANNING,
    href: '#discharge-planning',
    title: 'Discharge Planning'
  },
  {
    key: SocAssessmentSections.AUTHORIZATION,
    href: '#authorization',
    title: 'Authorization'
  },
  {
    key: SocAssessmentSections.VISIT_SCHEDULING,
    href: '#visit-scheduling',
    title: 'Visit Scheduling'
  },
  {
    key: SocAssessmentSections.PLAN_OF_CARE,
    href: '#plan-of-care',
    title: 'Plan of Care'
  },
  {
    key: SocAssessmentSections.SUPERVISORY_REVIEW,
    href: '#supervisory-review',
    title: 'Supervisory Review'
  },
  {
    key: SocAssessmentSections.NARRATIVE,
    href: '#narrative',
    title: 'Narrative'
  },
  {
    key: SocAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]

// Add sections here as they are migrated from controlled to uncontrolled
export const UNCONTROLLED_FORM_SECTION: Set<SocAssessmentSections> = new Set([
  SocAssessmentSections.ASSESSMENT_OVERVIEW,
  SocAssessmentSections.PATIENT_OVERVIEW,
  SocAssessmentSections.MEDICAL_BACKGROUND,
  SocAssessmentSections.MEDICATIONS,
  SocAssessmentSections.SKILLED_NEEDS,
  SocAssessmentSections.ADL_NEEDS,
  SocAssessmentSections.DISCHARGE_PLANNING,
  SocAssessmentSections.AUTHORIZATION,
  SocAssessmentSections.PLAN_OF_CARE,
  SocAssessmentSections.VISIT_SCHEDULING,
  SocAssessmentSections.SUPERVISORY_REVIEW,
  SocAssessmentSections.NARRATIVE,
  SocAssessmentSections.FINAL_STEPS
])
